export const allowedVideoTypes = ['video/mp4', 'video/quicktime'];
